import type { CSSProperties, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CoverFrameProps {
    ratio: number
    subjectX?: number
    subjectY?: number
    targetX?: number
    targetXWide?: number
    targetY?: number
    className?: string
    children: ReactNode
}

/**
 * Scales a box with the picture's own aspect ratio to cover the parent, like object-fit: cover,
 * while keeping a chosen subject point on screen. Anything positioned inside it in percentages
 * stays pinned to the same spot in the picture at every screen size.
 */
const CoverFrame: FC<CoverFrameProps> = ({
    ratio,
    subjectX = 0.5,
    subjectY = 0.5,
    targetX = 0.5,
    targetXWide,
    targetY = 0.5,
    className,
    children
}): ReactNode => {
    const style = {
        '--ratio': ratio,
        '--sx': subjectX,
        '--sy': subjectY,
        '--tx-base': targetX,
        '--tx-wide': targetXWide ?? targetX,
        '--ty': targetY
    } as CSSProperties

    return (
        <div className='absolute inset-0 overflow-hidden [container-type:size]'>
            <div style={style} className={cn('cover-frame', className)}>
                {children}
            </div>
        </div>
    )
}

export default CoverFrame
